import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UpdateAddressRequestModel } from 'src/app/core/types/UpdateAddressRequestModel';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReferenceDataService } from 'src/app/core/services/reference-data.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-update-address-modal',
	templateUrl: './update-address-modal.component.html',
	styleUrls: [ './update-address-modal.component.scss' ]
})
export class UpdateAddressModalComponent implements OnInit, OnDestroy {
	//Depends on initial state "model" to be set
	model: UpdateAddressRequestModel;

	addressForm: FormGroup = this.fb.group({
		street1: [ null, Validators.required ],
		street2: [ null ],
		city: [ null, Validators.required ],
		state: [ null, Validators.required ],
		zip: [ null, Validators.required ]
	});

	stateOptions: any[] = [];
	isCanceled: boolean = true;
	isSubmitted: boolean = false;

	private subscription: Subscription = new Subscription();

	constructor(public bsModalRef: BsModalRef, private fb: FormBuilder, private refDataService: ReferenceDataService) {
		const statesSubscription = this.refDataService.getStateList().subscribe((states) => {
			this.stateOptions = states;
		});
		this.subscription.add(statesSubscription);
	}

	ngOnInit() {
		this.addressForm.patchValue(this.model.address);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	onCancel() {
		this.bsModalRef.hide();
	}

	onSubmit() {
		this.isSubmitted = true;

		if (!this.addressForm.valid) {
			return;
		}

		this.model.address = this.addressForm.value;

		this.isCanceled = false;
		this.bsModalRef.hide();
	}

	// private statePipe(intValue: number): string {
	// 	const found = this.stateOptions.find((item) => item.key === +intValue);

	// 	return found ? found.value : '';
	// }
}
